import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Bouteilledoseur = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.78 82.94">
  <G fill={color}>
    <Path d="M15.33,16.04h16.2c2.96,0,5.37-2.32,5.37-5.17v-5.69c0-2.85-2.41-5.17-5.37-5.17H15.33c-2.96,0-5.37,2.32-5.37,5.17v5.69c0,2.85,2.41,5.17,5.37,5.17Z"/>
    <Path d="M43.13,26.83l-9.35-7.48c-.53-.43-1.19-.66-1.87-.66H14.96c-.68,0-1.34.23-1.87.66l-9.35,7.48c-2.37,1.9-3.73,4.72-3.73,7.76v39.76c0,4.74,3.86,8.6,8.6,8.6h29.67c4.74,0,8.6-3.86,8.6-8.6v-39.76c0-3.03-1.36-5.86-3.73-7.76ZM34.91,66.09c0,1.66-1.34,3-3,3H14.96c-1.66,0-3-1.34-3-3v-22.88c0-1.66,1.34-3,3-3h16.95c1.66,0,3,1.34,3,3v22.88Z"/>
    <Path d="M74.38,56.49c-1.14-1.35-2.81-2.13-4.58-2.13h-14.6c-1.77,0-3.44.78-4.58,2.13-1.14,1.35-1.62,3.13-1.32,4.87l2.89,16.62c.5,2.87,2.98,4.96,5.89,4.96h8.82c2.92,0,5.39-2.08,5.89-4.96l2.89-16.62c.3-1.74-.18-3.52-1.32-4.87ZM68.66,66.82h-12.33l-1.13-6.46,14.58-.02-1.12,6.49Z"/>
  </G>
</Svg>
);
};

export default Bouteilledoseur;
